import { useTheme } from '@emotion/react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcons from '@mui/icons-material/People';
import Loading from 'assets/images/loading.png';
import {
  Avatar,
  AvatarGroup,
  Badge,
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  Collapse,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import {
  addNote,
  getNotes,
  getApiCall,
  getOwnerCardActivity,
  postApiCall,
} from 'api/apiService';
import { ReactComponent as ForwardArrow } from 'assets/icons/forward_arrow.svg';
import { messageCardCont } from 'component/MessagingContainer/MessagingContainer.style';
import LiveActivityFeed from 'component/OwnerCard/LiveActivityFeed';
import { NotesTasks } from 'component/OwnerCard/NotesTasks';
import { TabPanel } from 'component/OwnerCard/OwnerCard';
import { USER_UPDATETASK, getUserCardActivity } from 'constant/app.config';
import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import {
  displayFlex,
  displayFlexColumn,
  fontsize10,
  fontsize14,
  fontsize8,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
// import { messageCardCont } from "component/MessagingContainer/MessagingContainer.style";
import {
  lastseen,
  lastseen6,
} from 'component/MessagingContainer/MessagingContainer';
import {
  GET_BUYER_COMMUNICATION,
  GET_VENDOR_COMMUNICATION,
} from 'constant/app.config';
import {
  getMoxoActionsByFilterForOther,
  getMoxoToken,
} from 'api/rcpapiService';
import Swal from 'sweetalert2';
import { Global, css } from '@emotion/react';
import Moxochat from 'component/Moxochat/Moxochat';
import { datacontext } from 'modules/AppLayout/AppLayout';
import dayjs from 'dayjs';

export const NotesImage = ({ color = '#666666' }) => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.12912 7.24498C3.12912 6.96476 3.31593 6.77794 3.59615 6.77794H9.57417C9.85439 6.77794 10.0412 6.96476 10.0412 7.24498C10.0412 7.5252 9.85439 7.71201 9.57417 7.71201H3.59615C3.36264 7.71201 3.12912 7.5252 3.12912 7.24498ZM3.59615 10.5142H9.57417C9.85439 10.5142 10.0412 10.3274 10.0412 10.0472C10.0412 9.76695 9.85439 9.58014 9.57417 9.58014H3.59615C3.31593 9.58014 3.12912 9.76695 3.12912 10.0472C3.12912 10.3274 3.36264 10.5142 3.59615 10.5142ZM3.59615 13.2697H7.1456C7.42582 13.2697 7.61264 13.0829 7.61264 12.8027C7.61264 12.5224 7.42582 12.3356 7.1456 12.3356H3.59615C3.31593 12.3356 3.12912 12.5224 3.12912 12.8027C3.12912 13.0362 3.36264 13.2697 3.59615 13.2697ZM17 10.234C17 10.4675 16.9066 10.701 16.7198 10.8878L10.4615 17.0527C10.3681 17.1461 10.2747 17.1928 10.1813 17.2395L7.65934 18.267C7.56593 18.3137 7.1456 18.4538 6.77198 18.0801C6.53846 17.8466 6.44505 17.5197 6.58516 17.1928L7.56593 14.6708C7.61264 14.5774 7.65934 14.484 7.75275 14.3906L12.2363 9.95377V4.30267H9.76099C9.48077 4.30267 9.29396 4.11586 9.29396 3.83564V1.50047H1.54121C1.21429 1.50047 0.934066 1.78069 0.934066 2.10761V15.3714C0.934066 15.6983 1.21429 15.9785 1.54121 15.9785H4.99725C5.27747 15.9785 5.46429 16.1653 5.46429 16.4455C5.46429 16.7257 5.27747 16.9126 4.99725 16.9126H1.54121C0.70055 16.9126 0 16.212 0 15.3714V2.10761C0 1.26696 0.70055 0.566406 1.54121 0.566406H9.76099C9.9478 0.566406 10.0412 0.659813 10.0879 0.706516L13.0302 3.50871C13.1703 3.64882 13.1703 3.83564 13.1703 3.83564V9.0197L14.011 8.17904C14.3846 7.80542 14.9451 7.80542 15.3187 8.17904L16.7198 9.58014C16.9066 9.76695 17 9.95377 17 10.234ZM10.228 3.3686H11.5357L11.3022 3.13509L10.228 2.10761V3.3686ZM9.29396 16.5856L8.26648 15.5115L7.56593 17.2862L9.29396 16.5856ZM16.0659 10.1873L14.6648 8.83289L8.78022 14.7175L10.1346 16.1186L16.0659 10.1873Z"
        fill={color}
      />
    </svg>
  );
};
export const TasksImage = ({ color = '#666666' }) => {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0347 2.21774H11.2791C11.0507 1.57355 10.4355 1.11082 9.71395 1.11082H9.06567C8.83724 0.46656 8.22172 0.00390625 7.50012 0.00390625C6.77852 0.00390625 6.16301 0.46656 5.93458 1.11082H5.28629C4.56477 1.11082 3.94958 1.57355 3.72111 2.21774H1.96555C1.05002 2.21774 0.305176 2.96258 0.305176 3.87811V17.2349C0.305176 18.1504 1.05002 18.8953 1.96555 18.8953H13.0347C13.9502 18.8953 14.6951 18.1504 14.6951 17.2349V3.87811C14.6951 2.96258 13.9502 2.21774 13.0347 2.21774ZM4.73283 2.77119C4.73283 2.46602 4.98112 2.21774 5.28629 2.21774H6.39321C6.69886 2.21774 6.94666 1.96993 6.94666 1.66428C6.94666 1.3591 7.19495 1.11082 7.50012 1.11082C7.8053 1.11082 8.05358 1.3591 8.05358 1.66428C8.05358 1.96993 8.30138 2.21774 8.60704 2.21774H9.71395C10.0191 2.21774 10.2674 2.46602 10.2674 2.77119V3.32465H4.73283V2.77119ZM13.5882 17.2349C13.5882 17.5401 13.3399 17.7883 13.0347 17.7883H1.96555C1.66037 17.7883 1.41209 17.5401 1.41209 17.2349V3.87811C1.41209 3.57293 1.66037 3.32465 1.96555 3.32465H3.62592V3.87811C3.62592 4.18376 3.87372 4.43157 4.17938 4.43157H10.8209C11.1265 4.43157 11.3743 4.18376 11.3743 3.87811V3.32465H13.0347C13.3399 3.32465 13.5882 3.57293 13.5882 3.87811V17.2349Z"
        fill={color}
      />
      <path
        d="M6.78459 9.64844C6.56849 9.43229 6.21804 9.43229 6.0019 9.64844L4.17943 11.4709L3.46385 10.7553C3.24774 10.5392 2.89729 10.5392 2.68115 10.7553C2.46501 10.9715 2.46501 11.3219 2.68115 11.538L3.7881 12.645C3.89614 12.753 4.03779 12.8071 4.17943 12.8071C4.32108 12.8071 4.46273 12.753 4.57077 12.645L6.78459 10.4311C7.00074 10.215 7.00074 9.86458 6.78459 9.64844Z"
        fill={color}
      />
      <path
        d="M6.78435 5.77344C6.56824 5.55729 6.21779 5.55729 6.00165 5.77344L4.17919 7.5959L3.46361 6.88031C3.2475 6.66417 2.89705 6.66417 2.68091 6.88031C2.46476 7.09646 2.46476 7.44687 2.68091 7.66301L3.78786 8.76997C3.89589 8.87804 4.03754 8.93205 4.17919 8.93205C4.32084 8.93205 4.46249 8.87804 4.57052 8.76997L6.78435 6.55614C7.00049 6.33999 7.00049 5.98958 6.78435 5.77344Z"
        fill={color}
      />
      <path
        d="M6.78459 13.5215C6.56849 13.3053 6.21804 13.3053 6.0019 13.5215L4.17943 15.344L3.46385 14.6284C3.24774 14.4123 2.89729 14.4123 2.68115 14.6284C2.46501 14.8446 2.46501 15.195 2.68115 15.4111L3.7881 16.518C3.89614 16.6261 4.03779 16.6801 4.17943 16.6801C4.32108 16.6801 4.46273 16.6261 4.57077 16.518L6.78459 14.3042C7.00074 14.088 7.00074 13.7376 6.78459 13.5215Z"
        fill={color}
      />
      <path
        d="M11.9277 6.7168H8.60692C8.30127 6.7168 8.05347 6.9646 8.05347 7.27025C8.05347 7.57591 8.30127 7.82371 8.60692 7.82371H11.9277C12.2333 7.82371 12.4811 7.57591 12.4811 7.27025C12.4811 6.9646 12.2333 6.7168 11.9277 6.7168Z"
        fill={color}
      />
      <path
        d="M11.9282 14.4668H8.60741C8.30176 14.4668 8.05396 14.7146 8.05396 15.0203C8.05396 15.3259 8.30176 15.5737 8.60741 15.5737H11.9282C12.2338 15.5737 12.4816 15.3259 12.4816 15.0203C12.4816 14.7146 12.2338 14.4668 11.9282 14.4668Z"
        fill={color}
      />
      <path
        d="M11.9277 10.5918H8.60692C8.30127 10.5918 8.05347 10.8396 8.05347 11.1453C8.05347 11.4509 8.30127 11.6987 8.60692 11.6987H11.9277C12.2333 11.6987 12.4811 11.4509 12.4811 11.1453C12.4811 10.8396 12.2333 10.5918 11.9277 10.5918Z"
        fill={color}
      />
    </svg>
  );
};

const CommunicationIcon = ({ color = '#666666' }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7898 0H5.16479C2.58026 0 0.446045 2.13422 0.446045 4.71875C0.446045 7.08219 2.23511 9.04234 4.51158 9.36094C4.65473 9.42822 4.99161 9.40625 5.16479 9.40625V10.8125C5.16479 10.9855 5.26001 11.1444 5.41245 11.2259C5.56295 11.3066 5.74839 11.2993 5.89358 11.2025L8.58795 9.40625H10.7898C13.3743 9.40625 15.5085 7.30328 15.5085 4.71875C15.5085 2.13422 13.3743 0 10.7898 0ZM5.16479 5.65625C4.64798 5.65625 4.22729 5.23556 4.22729 4.71875C4.22729 4.20194 4.64798 3.78125 5.16479 3.78125C5.68161 3.78125 6.10229 4.20194 6.10229 4.71875C6.10229 5.23556 5.68161 5.65625 5.16479 5.65625ZM7.97729 5.65625C7.46048 5.65625 7.03979 5.23556 7.03979 4.71875C7.03979 4.20194 7.46048 3.78125 7.97729 3.78125C8.49411 3.78125 8.91479 4.20194 8.91479 4.71875C8.91479 5.23556 8.49411 5.65625 7.97729 5.65625ZM10.7898 5.65625C10.273 5.65625 9.85229 5.23556 9.85229 4.71875C9.85229 4.20194 10.273 3.78125 10.7898 3.78125C11.3066 3.78125 11.7273 4.20194 11.7273 4.71875C11.7273 5.23556 11.3066 5.65625 10.7898 5.65625Z"
        fill={color}
      />
      <path
        d="M15.8661 7.19055C14.949 9.05468 13.004 10.3437 10.7898 10.3437H8.87176L6.41358 11.9825C5.97339 12.2765 5.41639 12.2917 4.96933 12.0521C4.51201 11.8076 4.22729 11.3325 4.22729 10.8124V10.2654C3.17117 10.0874 2.19623 9.60661 1.43126 8.93118C1.41523 9.08958 1.38354 9.24499 1.38354 9.40618C1.38354 11.9907 3.51776 14.0937 6.10229 14.0937H8.30414L10.9985 15.9212C11.1437 16.0179 11.3292 16.0253 11.4797 15.9445C11.6321 15.8631 11.7273 15.7042 11.7273 15.5312V14.0937C11.9005 14.0937 12.2374 14.1156 12.3805 14.0484C14.657 13.7298 16.446 11.7691 16.446 9.40618C16.446 8.61499 16.2315 7.8658 15.8661 7.19055Z"
        fill={color}
      />
    </svg>
  );
};

const Lock = () => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <svg
      width={matchessm ? '60' : '85'}
      height={matchessm ? '60' : '84'}
      viewBox="0 0 85 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M72.2499 31.5H66.9999V24.4999C66.9999 10.9905 56.0096 0 42.5 0C28.9904 0 18.0001 10.9905 18.0001 24.4999V31.5H12.7501C11.7827 31.5 11 32.2827 11 33.2501V77.0001C11 80.8607 14.1393 84 18.0001 84H67.0001C70.8607 84 74 80.8607 74 76.9999V33.2501C74 32.2827 73.2173 31.5 72.2499 31.5ZM47.7398 68.0569C47.7945 68.5507 47.6357 69.0464 47.3041 69.4173C46.9725 69.7881 46.4974 70.0001 46.0001 70.0001H39.0001C38.5028 70.0001 38.0277 69.7881 37.6961 69.4173C37.3645 69.0465 37.2055 68.5509 37.2603 68.0569L38.3643 58.1295C36.5716 56.8255 35.5001 54.7627 35.5001 52.5C35.5001 48.6394 38.6394 45.4999 42.5002 45.4999C46.3609 45.4999 49.5002 48.6393 49.5002 52.5C49.5002 54.7627 48.4287 56.8255 46.636 58.1295L47.7398 68.0569ZM56.4999 31.5H28.5001V24.4999C28.5001 16.7805 34.7805 10.5 42.5 10.5C50.2195 10.5 56.4999 16.7805 56.4999 24.4999V31.5V31.5Z"
        fill="#585858"
      />
    </svg>
  );
};

const ArrowDown = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.773438"
        y="0.5"
        width="23"
        height="23"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M13.1916 16.006C12.6967 16.5418 11.8501 16.5418 11.3552 16.006L7.28346 11.5982C6.54389 10.7976 7.11173 9.5 8.20165 9.5L16.3452 9.5C17.4351 9.5 18.003 10.7976 17.2634 11.5982L13.1916 16.006Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
const LocationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0214 1.66606C6.18054 1.65301 3.04331 4.70881 2.91792 8.53381L2.91406 8.77123C2.9779 10.6461 3.61579 12.4333 4.7393 13.9057L5.00316 14.25C6.07556 15.6136 7.34999 16.8105 8.78096 17.7969L9.12549 18.0289L9.17577 18.0683C9.66623 18.4207 10.3284 18.4207 10.8189 18.0683L10.8607 18.034C11.9962 17.2976 13.0432 16.4324 13.9811 15.4554C15.8879 13.437 17.0372 11.1754 17.0805 8.8785L17.0806 8.79322C17.0937 4.94262 14.0473 1.79574 10.234 1.66992L10.0214 1.66606ZM10.0161 2.93046C13.1648 2.94123 15.7213 5.45709 15.8163 8.59017L15.819 8.86642C15.7825 10.7921 14.7742 12.7763 13.0685 14.5819C12.1988 15.4878 11.2236 16.2931 10.166 16.9779L10.0955 17.0309C10.0385 17.0804 9.95403 17.0804 9.89707 17.0309L9.82856 16.9792C8.25298 15.9505 6.87014 14.6518 5.7433 13.1423C4.83565 11.9527 4.2978 10.5304 4.18954 9.04665L4.17363 8.74913C4.18433 5.59275 6.69244 3.02839 9.81588 2.93317L10.0161 2.93046ZM9.99821 6.16733C8.50788 6.16733 7.29974 7.37921 7.29974 8.87414C7.29974 10.3691 8.50788 11.5809 9.99821 11.5809C11.4885 11.5809 12.6967 10.3691 12.6967 8.87414C12.6967 7.37921 11.4885 6.16733 9.99821 6.16733ZM9.99715 7.43178C10.7913 7.43178 11.435 8.07751 11.435 8.87406C11.435 9.67062 10.7913 10.3163 9.99715 10.3163C9.20305 10.3163 8.5593 9.67062 8.5593 8.87406C8.5593 8.07751 9.20305 7.43178 9.99715 7.43178Z"
        fill="#112347"
      />
    </svg>
  );
};

const TaskDeleteIcon = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.655 21.0002H12.3268C11.9162 21.0002 11.5732 20.6793 11.5459 20.2696L11.0381 12.6523H19.9436L19.4358 20.2696C19.4086 20.6793 19.0656 21.0002 18.655 21.0002ZM11.5958 13.1741L12.0665 20.2349C12.0756 20.3715 12.1899 20.4784 12.3268 20.4784H18.6549C18.7918 20.4784 18.9061 20.3715 18.9151 20.2349L19.3859 13.1741H11.5958Z"
        fill="#A58BC9"
      />
      <path
        d="M19.9252 12.1309H11.0557V10.8266C11.0557 10.395 11.4067 10.0439 11.8383 10.0439H19.1426C19.5742 10.0439 19.9252 10.395 19.9252 10.8266V12.1309ZM11.5774 11.6092H19.4035V10.8266C19.4035 10.6827 19.2865 10.5657 19.1426 10.5657H11.8383C11.6944 10.5657 11.5774 10.6827 11.5774 10.8266V11.6092Z"
        fill="#A58BC9"
      />
      <path
        d="M20.7082 11.6084H10.2734V12.1301H20.7082V11.6084Z"
        fill="#A58BC9"
      />
      <path
        d="M14.1861 19.4342H13.6643C13.3762 19.4342 13.1426 19.2006 13.1426 18.9124V14.7385C13.1426 14.4504 13.3762 14.2168 13.6643 14.2168H14.1861C14.4742 14.2168 14.7078 14.4504 14.7078 14.7385V18.9124C14.7078 19.2006 14.4742 19.4342 14.1861 19.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M14.1862 19.6952H13.6644C13.2329 19.6952 12.8818 19.3441 12.8818 18.9126V14.7387C12.8818 14.3071 13.2329 13.9561 13.6644 13.9561H14.1862C14.6177 13.9561 14.9688 14.3071 14.9688 14.7387V18.9126C14.9688 19.3442 14.6177 19.6952 14.1862 19.6952ZM13.6644 14.4778C13.5206 14.4778 13.4036 14.5948 13.4036 14.7387V18.9126C13.4036 19.0564 13.5206 19.1734 13.6644 19.1734H14.1862C14.33 19.1734 14.4471 19.0564 14.4471 18.9126V14.7387C14.4471 14.5948 14.33 14.4778 14.1862 14.4778H13.6644Z"
        fill="#A58BC9"
      />
      <path
        d="M17.3169 19.4342H16.7952C16.507 19.4342 16.2734 19.2006 16.2734 18.9124V14.7385C16.2734 14.4504 16.507 14.2168 16.7952 14.2168H17.3169C17.6051 14.2168 17.8387 14.4504 17.8387 14.7385V18.9124C17.8387 19.2006 17.6051 19.4342 17.3169 19.4342Z"
        fill="#FCFCFC"
      />
      <path
        d="M17.317 19.6952H16.7953C16.3638 19.6952 16.0127 19.3441 16.0127 18.9126V14.7387C16.0127 14.3071 16.3638 13.9561 16.7953 13.9561H17.317C17.7486 13.9561 18.0997 14.3071 18.0997 14.7387V18.9126C18.0997 19.3442 17.7486 19.6952 17.317 19.6952ZM16.7953 14.4778C16.6515 14.4778 16.5344 14.5948 16.5344 14.7387V18.9126C16.5344 19.0564 16.6515 19.1734 16.7953 19.1734H17.317C17.4609 19.1734 17.5779 19.0564 17.5779 18.9126V14.7387C17.5779 14.5948 17.4609 14.4778 17.317 14.4778H16.7953Z"
        fill="#A58BC9"
      />
      <path
        d="M16.7952 10.5652H14.1865V9.78261C14.1865 9.35108 14.5376 9 14.9691 9H16.0126C16.4441 9 16.7952 9.35108 16.7952 9.78261V10.5652ZM14.7083 10.0435H16.2735V9.78261C16.2735 9.63877 16.1565 9.52174 16.0126 9.52174H14.9691C14.8253 9.52174 14.7083 9.63877 14.7083 9.78261V10.0435Z"
        fill="#A58BC9"
      />
    </svg>
  );
};
const TaskEditIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.52713 14.378L7.0525 14.5253C6.43805 14.7159 5.78336 15.0481 5.15941 15.4858L5.14931 15.4929L4.70044 15.0441L4.70764 15.034C5.14523 14.41 5.47743 13.7553 5.6681 13.1409L5.81535 12.6664C5.84571 12.5685 5.79101 12.4645 5.69319 12.4341C5.59552 12.4039 5.49139 12.4584 5.46096 12.5563L5.31371 13.0309C5.13432 13.609 4.81971 14.228 4.40386 14.8208L4.30715 14.9585C4.25535 15.0322 4.26403 15.1326 4.32778 15.1963L4.99709 15.8655C5.03294 15.9014 5.08051 15.9198 5.12838 15.9198C5.16542 15.9198 5.20267 15.9088 5.23496 15.8861L5.37256 15.7895C5.96535 15.3736 6.58426 15.059 7.1625 14.8796L7.63712 14.7323C7.73495 14.702 7.78972 14.598 7.75929 14.5002C7.72893 14.4023 7.62503 14.3476 7.52713 14.378Z"
        fill="#A58BC9"
      />
      <path
        d="M13.3246 4.92548C13.2521 4.85297 13.1347 4.85297 13.0623 4.92548L6.70449 11.2833L5.98798 11.9999C5.91547 12.0723 5.91547 12.1898 5.98798 12.2622L7.93184 14.2061C7.96806 14.2423 8.01556 14.2604 8.06306 14.2604C8.11056 14.2604 8.15799 14.2423 8.19428 14.2061L8.91086 13.4895L15.2686 7.1317C15.3411 7.05927 15.3411 6.94178 15.2686 6.86934L13.3246 4.92548ZM8.06299 13.8125L6.38148 12.131L6.83563 11.6769L8.33849 13.1796L8.5172 13.3584L8.06299 13.8125ZM8.77957 13.0959L7.27671 11.5931L7.09799 11.4144L13.1934 5.31906L14.8749 7.00056L8.77957 13.0959Z"
        fill="#A58BC9"
      />
      <path
        d="M15.5528 5.50901L14.6849 4.64102C14.4967 4.45295 14.1907 4.45303 14.0027 4.64102L13.8015 4.84216C13.7289 4.91467 13.7289 5.03208 13.8015 5.1046C13.874 5.17711 13.9914 5.17703 14.0638 5.1046L14.265 4.90346C14.3084 4.86012 14.3789 4.86004 14.4225 4.90346L15.2904 5.77145C15.3114 5.79253 15.323 5.82051 15.323 5.8502C15.323 5.87996 15.3114 5.90786 15.2904 5.92894L15.0893 6.13008C15.0168 6.20259 15.0168 6.32 15.0893 6.39251C15.1255 6.42873 15.173 6.44684 15.2205 6.44684C15.268 6.44684 15.3155 6.42873 15.3517 6.39251L15.5529 6.19138C15.644 6.10024 15.6942 5.97911 15.6942 5.8502C15.6941 5.72128 15.644 5.60008 15.5528 5.50901Z"
        fill="#A58BC9"
      />
    </svg>
  );
};
const CheckedRoundIconUnchecked = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="16.205"
        height="16.205"
        rx="8.1025"
        fill="#C4C4C4"
        fill-opacity="0.22"
      />
    </svg>
  );
};
const CheckedRoundIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.273438"
        width="16.205"
        height="16.205"
        rx="8.1025"
        fill="#C4C4C4"
        fill-opacity="0.22"
      />
      <path
        d="M4 9.5L7.33333 13L14 6"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const CollapseIcon = () => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 24.0703L20.9289 16.9992L13.8579 24.0703"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
      />
      {/* <rect opacity="0.1" x="0.5" y="0.5" width="40" height="40" rx="4.5" stroke="#112347"/> */}
    </svg>
  );
};
const ExpandIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <rect opacity="0.1" x="0.5" y="0.5" width="40" height="40" rx="4.5" stroke="#112347" /> */}
      <path
        d="M15.5 17L20.5 22L25.5 17"
        stroke="#0065FC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExpendedCardDocumentation = ({
  propertyValue,
  show,
  buyerId,
  activitywidth,
  rowData,
  marketShow,
  proid,
  proUniqueId,
  userEmail,
  userType,
  ownercardprop = userType == 'Vendor' ? true : false,
  selectedProperty,
  Address,
  fromSearch,
  catSelected,
  noteSelected,
  taskId,
  taskBinderId,
  isPipelineManagement,
}) => {
  const [tabValue, setTabValue] = React.useState(0);

  const [data, setData] = React.useState([]);
  const [loaderpart, setLoaderpart] = React.useState(false);
  const [noteToEdit, setNoteToEdit] = useState(null);
  const [isNoteEdit, setIsNoteEdit] = useState(null);
  const [taskToEdit, setTaskToEdit] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const updateTaskScrollRef = useRef(null);
  const updateNoteScrollRef = useRef(null);

  // const buyID = localStorage.getItem("buyerID");
  const [newActiveValue, setActiveValue] = React.useState(0);
  const getNoteListApi = (id, ownercardprop) => {
    const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
    const targetUserId = ownercardprop ? rowData?.user?.userId : buyerId;

    getNotes({
      receiverType: targetUserType,
      receiverId: targetUserId,
      filter: 'property',
      propertyId: proid,
    }).then((res) => {
      setData(res?.data);
    });
  };
  const taskSectionRef = useRef(null);
  const [scrollToNoteId, setScrollToNoteId] = useState(null);

  useEffect(() => {
    if (fromSearch) {
      if (catSelected == 'task') {
        setActiveValue(2);
        getTask();
        requestAnimationFrame(() => {
          taskSectionRef?.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      }
      if (catSelected == 'notes') {
        setActiveValue(4);
        getNoteListApi(buyerId, ownercardprop);
        // for particular notes to display
        setTimeout(() => {
          setScrollToNoteId(noteSelected);
        }, 300);
      }
    }
  }, [proid, proUniqueId]);

  useEffect(() => {
    getNoteListApi('', ownercardprop);
    postCommunication(ownercardprop);
  }, [proid, marketShow, proUniqueId]);
  const handleActiveChange = (event, newActiveValue) => {
    setActiveValue(newActiveValue);
  };

  const params = useParams();

  function b11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const theme = useTheme();
  const isMd = useMediaQuery((theme) => theme.breakpoints.only('md'));
  const isXs = useMediaQuery((theme) => theme.breakpoints.only('xs'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const [communicationData, setCommunicationData] = useState({});

  const getData = () => {
    if (ownercardprop) {
      getOwnerCardActivity(proid, rowData?.user?.userId, marketShow);
    } else {
      const id = marketShow ? 0 : proid;
      getApiCall(getUserCardActivity + `/${id}/${buyerId}/Default`);
    }
  };

  const [filteredTodos, setFilteredTodos] = useState({
    active: [],
    completed: [],
    pending: [],
  });

  const [sortedCategories, setSortedCategories] = useState();

  const taskRefs = useRef({}); // Store references to task elements
  const [highlightKey, setHighlightKey] = useState(null);
  // Function to scroll to the task
  const scrollToTask = (binderId, taskId) => {
    const key = `${binderId}-${taskId}`;
    const el = taskRefs.current[key];

    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setHighlightKey(key);

      // remove highlight after 2s (same as animation duration)
      setTimeout(() => {
        setHighlightKey(null);
      }, 2000);
    }
  };

  useEffect(() => {
    if (fromSearch && catSelected === 'task') {
      // delay scroll until the DOM updates
      const timer = setTimeout(() => {
        scrollToTask(taskBinderId, taskId);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [sortedCategories]);

  const [expandedCategories, setExpandedCategories] = useState({
    active: true,
    pending: true,
    completed: true,
  });

  const handleExpandCollapse = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const formatTimestamp = (timestamp, includeDate = true) => {
    const timestampInMilliseconds = Number(timestamp);

    if (isNaN(timestampInMilliseconds) || !isFinite(timestampInMilliseconds)) {
      return 'Invalid Timestamp';
    }
    const date = new Date(timestampInMilliseconds);
    if (includeDate) {
      const options = {
        day: 'numeric',
        month: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    } else {
      const options = { hour: 'numeric', minute: 'numeric', hour12: true };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    }
  };

  const formatDueTime = (dueTime) => {
    if (!dueTime) {
      return '';
    }
    const now = new Date().setHours(0, 0, 0, 0);
    const dueDate = new Date(dueTime).setHours(0, 0, 0, 0);

    const diffInDays = Math.floor((dueDate - now) / (24 * 60 * 60 * 1000));

    if (diffInDays === 0) {
      return 'Today';
    } else if (diffInDays === 1) {
      return 'Tomorrow';
    } else if (diffInDays === -1) {
      return 'Yesterday at ' + formatTimestamp(dueTime, false);
    } else {
      return formatTimestamp(dueTime);
    }
  };

  const getTask = async () => {
    setLoaderpart(true);
    setFilteredTodos({ active: [], completed: [], pending: [] });

    try {
      const buyermoxotoken = await getMoxoToken(userEmail); //get moxo token for buyer

      const res = await getMoxoActionsByFilterForOther(
        'task',
        buyermoxotoken?.data?.access_token
      ); //get all buyer task for this property

      const result = {
        active: [],
        pending: [],
        completed: [],
      };

      if (res?.data?.length > 0) {
        res.data.forEach((item) => {
          const trans = item?.transobject;

          if (!trans) return;

          // ✅ filter by propertyUniqueId (your existing logic)
          if (trans.propertyUniqueId !== proUniqueId) return;

          const status = trans?.status?.toLowerCase();
          const now = new Date();
          const timestamp = new Date(trans?.expiration_date);

          if (status === 'completed') {
            result.completed.push(item);
          } else if (timestamp > now) {
            result.active.push(item);
          } else if (timestamp < now) {
            result.pending.push(item);
          }
        });
      }

      setFilteredTodos(result);
    } catch (error) {
      console.error('Error in getTask', error);
      setFilteredTodos({ active: [], completed: [], pending: [] });
    } finally {
      setLoaderpart(false);
    }
  };

  async function filterfunc(filter) {
    let active = [];
    let pending = [];
    let completed = [];
    filter.active.map(async (value) => {
      let status = false;
      if (value?.transobject?.propertyUniqueId == proUniqueId) {
        status = true;
      }
      if (status == true) {
        active.push(value);
      }
    });
    filter.pending.map(async (value) => {
      let status = false;
      if (value?.transobject?.propertyUniqueId == proUniqueId) {
        status = true;
      }
      if (status == true) {
        pending.push(value);
      }
    });
    filter.completed.map(async (value) => {
      let status = false;
      if (value?.transobject?.propertyUniqueId == proUniqueId) {
        status = true;
      }
      if (status == true) {
        completed.push(value);
      }
    });

    await setFilteredTodos(() => ({
      active: active,
      pending: pending,
      completed: completed,
    }));

    setTimeout(() => {
      handleExpandCollapse('active');
      handleExpandCollapse('active');
      setLoaderpart(false);
    }, 3000);
  }

  useEffect(() => {
    setLoaderpart(true);
    getTask();
  }, [proid, proUniqueId]);

  useLayoutEffect(() => {
    const categoryOrder = ['active', 'pending', 'completed'];
    setSortedCategories(
      Object.entries(filteredTodos).sort(
        ([categoryA], [categoryB]) =>
          categoryOrder.indexOf(categoryA) - categoryOrder.indexOf(categoryB)
      )
    );
  }, [filteredTodos]);

  const postCommunication = async (ownercardprop) => {
    let propertyId = proid;
    const inputData = {
      propertyId: marketShow ? 0 : propertyId,
      ...(isPipelineManagement || userType === 'Vendor' || userType === 'Owner'
        ? { vendorId: buyerId }
        : { buyerId: buyerId }),
      filter: marketShow ? 'market' : 'property',
    };

    if (ownercardprop === false) {
      postApiCall(GET_BUYER_COMMUNICATION, inputData).then(async (res) => {
        setCommunicationData(res?.data?.binderList);
      });
    } else {
      postApiCall(GET_VENDOR_COMMUNICATION, inputData).then(async (res) => {
        setCommunicationData(res?.data?.binderList);
      });
    }
  };

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches1400 = useMediaQuery(theme.breakpoints.down(1400));
  const matches1000 = useMediaQuery(theme.breakpoints.down(1000));
  const matches1600 = useMediaQuery(theme.breakpoints.down(1600));

  return (
    <>
      <Grid
        sx={{
          border: '0.5px solid #E4E4E4 ',
          background: '#FFFFFF',
          borderRadius: '5px',
          marginTop: '20px',
          p: '0px',
          width: matchessm
            ? '100%'
            : ownercardprop && show && matches1600
            ? '96%'
            : matchessm
            ? '94.5%'
            : 'auto',
          marginLeft:
            isPipelineManagement && ownercardprop
              ? '30px'
              : matchessm
              ? '0px'
              : ownercardprop && matches1000
              ? 'none'
              : (ownercardprop && matches1400) ||
                ((isMd || isSm || isXs) && !ownercardprop)
              ? '10px'
              : 'none',
          position: 'relative',
        }}
      >
        {!Address && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: '30%',
              left: '50%',
              transform: 'translate(-50%, -10%)',
              zIndex: 2,
              padding: '20px',
              textAlign: 'center',
            }}
          >
            <Box>
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '10px' : '16px',
                  color: '#585858',
                }}
              >
                Request Property Insights from Listing Agent
              </Typography>
            </Box>
            <Box>
              <Lock />
            </Box>
            <Box>
              <Button
                sx={{
                  ...poppins600,
                  fontSize: matchessm ? '10px' : '16px',
                  color: '#6C2AD2',
                  height: '35px',
                  background: 'rgba(108, 42, 210, 0.1)',
                  borderRadius: ' 5px',
                  textTransform: 'none',
                }}
              >
                Yes, request access
              </Button>
            </Box>
          </Box>
        )}
        <Stack
          sx={{
            filter: !Address ? 'blur(3px)' : 'none',
            WebkitFilter: !Address ? 'blur(3px)' : 'none',
            pointerEvents: !Address ? 'none' : 'auto',
            opacity: !Address ? 0.9 : 1,
            // border:"2px solid pink"
          }}
        >
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: '10px',
            }}
          >
            <Grid item sx={{ width: '100%' }}>
              <NotesTasks
                getNoteListApi={getNoteListApi}
                rowData={rowData}
                setData={setData}
                show={show}
                buyerId={buyerId}
                ownercardprop={ownercardprop}
                proid={proid}
                selectedProperty={selectedProperty}
                setNoteToEdit={setNoteToEdit}
                noteToEdit={noteToEdit}
                isNoteEdit={isNoteEdit}
                setIsNoteEdit={setIsNoteEdit}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                taskToEdit={taskToEdit}
                setTaskToEdit={setTaskToEdit}
                updateTaskScrollRef={updateTaskScrollRef}
                updateNoteScrollRef={updateNoteScrollRef}
                getTask={getTask}
                tabValue={tabValue}
                setTabValue={setTabValue}
              />
            </Grid>
          </Stack>
          <Stack
            sx={{
              background: '#F8F8F8',
              borderRadius: '5px',
              padding: '5px 0',
            }}
          >
            <Tabs
              value={newActiveValue}
              onChange={handleActiveChange}
              variant="fullWidth"
              style={{
                display: 'flex',
                gap: '10px',
                justifyContent: 'center',
                height: '20px',
                alignItems: 'center',
              }}
              sx={{
                '& .MuiTabs-indicator': { display: 'none' },
                '.MuiTab-root.Mui-selected::after': {
                  backgroundColor: '#6d2ad1ff',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: '#6C2AD2',

                  backgroundColor: '#FFFFFF',
                  boxShadow: ' 0px 1px 4px rgba(0, 0, 0, 0.15)',
                  borderRadius: '5px',
                  padding: '10px 15px',
                  gap: '10px',
                  minWidth: isMd || isSm || isXs ? '1px' : 'none',
                },
              }}
            >
              <Tab
                style={{
                  minHeight: '41px',
                  padding: '10px 15px',
                  // margin: window.innerWidth < 1000 || show ? "0px" : "10px",
                  margin: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: window.innerWidth < 1000 || show ? '3px' : '2px',
                  // marginLeft: window.innerWidth < 1150 || show ? "0px" : "30px",
                  minWidth: isMd || isSm || isXs ? '1px' : 'none',
                }}
                label={
                  window.innerWidth <= 1650 ? null : (
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '500',
                        fontSize:
                          window.innerWidth <= 1750 && show
                            ? '10px'
                            : window.innerWidth <= 1850 && show
                            ? '12px'
                            : '14px',
                        whiteSpace: 'nowrap',
                        // color: "#666666",
                      }}
                    >
                      {/* Activity Feed */}
                      All Activities
                    </Typography>
                  )
                }
                icon={
                  <PeopleIcons
                    color={newActiveValue == 0 ? '#6C2AD2' : '#666666'}
                  />
                }
                // disabled={isEmpty(data)}
                iconPosition="start"
                {...b11yProps(0)}
                sx={[
                  {
                    color: '#666666',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '14px',
                    display: 'inline',
                    textTransform: 'capitalize',
                    textColor: '#6C2AD2',
                    indicatorColor: '#6C2AD2',
                  },
                ]}
              />
              <Tab
                onClick={getData}
                style={{
                  minHeight: '41px',
                  padding: '10px 30px',
                  margin: '5px',
                  display: 'flex',
                  gap: window.innerWidth < 1000 || show ? '3px' : '0px',
                  // marginLeft: window.innerWidth < 1150 || show ? "0px" : "30px",
                  minWidth: isMd || isSm || isXs ? '1px' : 'none',
                }}
                label={
                  window.innerWidth <= 1650 ? null : (
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '500',
                        fontSize:
                          window.innerWidth <= 1750 && show
                            ? '10px'
                            : window.innerWidth <= 1850 && show
                            ? '12px'
                            : '14px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Property Activity
                    </Typography>
                  )
                }
                icon={
                  <MonetizationOnIcon
                    color={newActiveValue == 1 ? '#6C2AD2' : '#666666'}
                  />
                }
                // disabled={isEmpty(data)}
                iconPosition="start"
                {...b11yProps(1)}
                sx={[
                  {
                    color: '#666666',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '14px',
                    display: 'inline',
                    textTransform: 'capitalize',
                    textColor: '#6C2AD2',
                    indicatorColor: '#6C2AD2',
                  },
                ]}
              />
              <Tab
                // onClick={getTask}
                ref={taskSectionRef}
                id="task-section"
                style={{
                  minHeight: '41px',
                  padding: '10px 15px',
                  margin: '5px',
                  display: 'flex',
                  gap: window.innerWidth < 1000 || show ? '3px' : '10px',
                  // marginLeft: window.innerWidth < 1150 || show ? "0px" : "30px",
                  minWidth: isMd || isSm || isXs ? '1px' : 'none',
                }}
                label={
                  window.innerWidth <= 1650 ? null : (
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '500',
                        fontSize:
                          window.innerWidth <= 1750 && show
                            ? '10px'
                            : window.innerWidth <= 1850 && show
                            ? '12px'
                            : '14px',
                        // color: "#666666",
                      }}
                    >
                      Tasks
                    </Typography>
                  )
                }
                icon={
                  <TasksImage
                    color={newActiveValue == 2 ? '#6C2AD2' : '#666666'}
                  />
                }
                // disabled={isEmpty(data)}
                iconPosition="start"
                {...b11yProps(3)}
                sx={[
                  {
                    color: '#666666',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '14px',
                    display: 'inline',
                    textTransform: 'capitalize',
                    textColor: '#6C2AD2',
                    indicatorColor: '#6C2AD2',
                  },
                ]}
              />
              <Tab
                style={{
                  minHeight: '41px',
                  padding: '10px 15px',
                  margin: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: window.innerWidth < 1000 || show ? '3px' : '10px',
                  // marginLeft: window.innerWidth < 1150 || show ? "0px" : "30px",
                  minWidth: 'fit-content',
                }}
                label={
                  window.innerWidth <= 1650 ? null : (
                    <Badge
                      badgeContent={
                        communicationData?.data?.unread_feeds &&
                        communicationData?.data?.unread_feeds
                      }
                      color="error"
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500',
                          fontSize:
                            window.innerWidth <= 1750 && show
                              ? '10px'
                              : window.innerWidth <= 1850 && show
                              ? '12px'
                              : '14px',
                          whiteSpace: 'nowrap',
                          paddingRight: '10px',
                          // color: "#666666",
                        }}
                      >
                        {/* Activity Feed */}
                        Communication
                      </Typography>
                    </Badge>
                  )
                }
                icon={
                  <CommunicationIcon
                    color={newActiveValue == 3 ? '#6C2AD2' : '#666666'}
                  />
                }
                // disabled={isEmpty(data)}
                iconPosition="start"
                {...b11yProps(0)}
                sx={[
                  {
                    color: '#666666',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '14px',
                    display: 'inline',
                    textTransform: 'capitalize',
                    textColor: '#6C2AD2',
                    indicatorColor: '#6C2AD2',
                  },
                ]}
              />
              <Tab
                //  ref={notesSectionRef} id="notes-section"
                onClick={() => getNoteListApi(buyerId, ownercardprop)}
                style={{
                  minHeight: '41px',
                  padding: '10px 15px',
                  margin: '5px',
                  display: 'flex',
                  gap: window.innerWidth < 1000 || show ? '3px' : '10px',
                  // marginLeft: window.innerWidth < 1150 || show ? "0px" : "30px",
                  minWidth: isMd || isSm || isXs ? '1px' : 'none',
                }}
                label={
                  window.innerWidth <= 1650 ? null : (
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '500',
                        fontSize:
                          window.innerWidth <= 1750 && show
                            ? '10px'
                            : window.innerWidth <= 1850 && show
                            ? '12px'
                            : '14px',
                        // color: "#666666",
                      }}
                    >
                      All Notes
                    </Typography>
                  )
                }
                icon={
                  <NotesImage
                    color={newActiveValue == 4 ? '#6C2AD2' : '#666666'}
                  />
                }
                // disabled={isEmpty(data)}
                iconPosition="start"
                {...b11yProps(3)}
                sx={[
                  {
                    color: '#666666',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '14px',
                    display: 'inline',
                    textTransform: 'capitalize',
                    textColor: '#6C2AD2',
                    indicatorColor: '#6C2AD2',
                  },
                ]}
              />
            </Tabs>
          </Stack>
          <Box sx={{ marginTop: '20px' }}>
            <TabPanel value={newActiveValue} index={0}>
              <AllActivities />
            </TabPanel>
            <TabPanel value={newActiveValue} index={1}>
              {/* <OwnerExpandedTab /> */}
              <Box sx={{ width: '97%' }}>
                <LiveActivityFeed
                  buyerId={buyerId}
                  agentindividual={ownercardprop ? false : true}
                  activitywidth={activitywidth}
                  rowData={rowData}
                  proid={proid}
                  ownercardprop={ownercardprop}
                  marketShow={marketShow}
                  removeBorder={true}
                  isPipelineManagement={isPipelineManagement}
                />
              </Box>
            </TabPanel>
            <TabPanel value={newActiveValue} index={2}>
              {loaderpart ? (
                <Grid
                  sx={{ display: 'flex', justifyContent: 'center', p: '10%' }}
                >
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '75px', width: '75px' }}
                  />
                </Grid>
              ) : (
                sortedCategories?.map(([category, todos]) => (
                  <div key={category}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '10px',
                        backgroundColor: '#F8F8F8',
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins',
                          fontWeight: 500,
                          fontSize: '20px',
                          color: '#000000',
                          marginLeft: '15px',
                        }}
                      >
                        {category === 'pending'
                          ? 'Overdue'
                          : category === 'active'
                          ? 'Due'
                          : category === 'completed'
                          ? 'Completed'
                          : category}
                      </Typography>
                      <IconButton
                        onClick={() => handleExpandCollapse(category)}
                        disableRipple
                      >
                        {expandedCategories[category] ? (
                          <CollapseIcon />
                        ) : (
                          <ExpandIcon />
                        )}
                      </IconButton>
                    </Box>
                    <Collapse in={expandedCategories[category]}>
                      {todos.length > 0 ? (
                        <Stack direction={'column'} spacing={2} sx={{ p: 2 }}>
                          {todos.map((todo, index) => {
                            const transId = todo.transobject?.id;
                            const binderId = todo.binder_id;
                            const key = `${binderId}-${transId}`;
                            return (
                              <div
                                key={key}
                                ref={(el) => (taskRefs.current[key] = el)}
                              >
                                <TaskListCard
                                  todo={todo}
                                  key={index}
                                  objectType={
                                    todo.transobject
                                      ? todo.transobject.type
                                      : todo.object_type
                                  }
                                  addedBy={
                                    todo.transobject?.creator?.name || ''
                                  }
                                  description={
                                    todo.transobject
                                      ? todo.transobject.sub_title
                                      : 'Document E-Sign assigned'
                                  }
                                  titleName={
                                    todo.transobject
                                      ? todo.transobject.title
                                      : ''
                                  }
                                  createdTime={formatTimestamp(
                                    todo.transobject
                                      ? todo.transobject.created_time
                                      : ''
                                  )}
                                  dueTime={formatDueTime(
                                    todo.transobject
                                      ? todo.transobject.expiration_date
                                      : ''
                                  )}
                                  completed={category === 'completed'}
                                  pending={category === 'pending'}
                                  selectedProperty={selectedProperty}
                                  proid={proid}
                                  transId={
                                    todo.transobject
                                      ? todo.transobject.id
                                      : null
                                  }
                                  binderId={todo.binder_id}
                                  buyerId={buyerId}
                                  setTaskToEdit={setTaskToEdit}
                                  taskToEdit={taskToEdit}
                                  setIsEdit={setIsEdit}
                                  getTask={getTask}
                                  updateTaskScrollRef={updateTaskScrollRef}
                                  updateNoteScrollRef={updateNoteScrollRef}
                                  tabValue={tabValue}
                                  setTabValue={setTabValue}
                                  isHighlighted={key === highlightKey}
                                  setNoteToEdit={setNoteToEdit}
                                  noteToEdit={noteToEdit}
                                  isNoteEdit={isNoteEdit}
                                  setIsNoteEdit={setIsNoteEdit}
                                />
                              </div>
                            );
                          })}
                        </Stack>
                      ) : (
                        <Typography
                          sx={{
                            ...poppins500,
                            fontSize: '16px',
                            color: '#585858',
                            marginLeft: '15px',
                          }}
                        >
                          {`No ${
                            category === 'completed'
                              ? 'task is completed'
                              : category === 'pending'
                              ? 'pending task available'
                              : 'active task available'
                          }`}
                        </Typography>
                      )}
                    </Collapse>
                  </div>
                ))
              )}
            </TabPanel>
            <TabPanel value={newActiveValue} index={3}>
              <CommunicationCard
                buyerId={buyerId}
                ownercardprop
                marketShow={marketShow}
                communicationData={communicationData}
              />
            </TabPanel>
            <TabPanel value={newActiveValue} index={4}>
              {/* <OwnerExpandedTab /> */}
              <NotesCard
                setNoteToEdit={setNoteToEdit}
                noteToEdit={noteToEdit}
                isNoteEdit={isNoteEdit}
                setIsNoteEdit={setIsNoteEdit}
                tabValue={tabValue}
                setData={setData}
                setTabValue={setTabValue}
                data={data}
                buyerId={buyerId}
                rowData={rowData}
                getNoteListApi={getNoteListApi}
                ownercardprop={ownercardprop}
                targetNoteId={scrollToNoteId}
                updateNoteScrollRef={updateNoteScrollRef}
                proid={proid}
              />
            </TabPanel>
          </Box>
        </Stack>
      </Grid>
      {/* {propertyValue === 0 && show && !matches870 &&( */}
    </>
  );
};

function NotesCard({
  buyerId,
  data,
  setData,
  ownercardprop,
  targetNoteId,
  setNoteToEdit,
  setIsNoteEdit,
  noteToEdit,
  isNoteEdit,
  tabValue,
  updateNoteScrollRef,
  setTabValue,
  rowData,
  proid,
}) {
  const globalStyles = css`
    @keyframes blink {
      0% {
        background: linear-gradient(
          90deg,
          #e3f2fd,
          #ffffff
        ); /* very light blue */
      }
      50% {
        background: linear-gradient(
          90deg,
          #bbdefb,
          #e3f2fd
        ); /* medium light blue */
      }
      100% {
        background: linear-gradient(90deg, #e3f2fd, #ffffff);
      }
    }
  `;

  const highlightStyle = {
    animation: 'blink 2s ease-in-out 2',
    border: '2px solid rgb(25,118,210)',
  };

  const notesSubject = {
    color: '#666',
    fontFamily: 'poppins',
    fontSize: '16px',
    fontWeight: 500,
    textTransform: 'capitalize',
  };
  const notesMidLine = {
    color: '#666',
    fontFamily: 'poppins',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'capitalize',
  };
  const [highlightedNoteId, setHighlightedNoteId] = useState(null);
  const cardRefs = useRef({});
  // Scroll to the specific card
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDeleteNote = (item) => {
    const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
    const targetUserId = ownercardprop ? rowData?.user?.userId : buyerId;

    let input = {
      receiverType: targetUserType,
      receiverId: targetUserId,
      propertyId: item.propertyId || proid || 0,
      subject: item.subject,
      message: item.notesMessage,
      isDelete: 1,
      notesId: item.noteId,
    };
    addNote(input).then((res) => {
      setNoteToEdit(null);
      setIsNoteEdit(null);
      getNotes({
        receiverType: targetUserType,
        receiverId: targetUserId,
        filter: 'property',
        propertyId: item.propertyId || proid || 0,
      }).then((res) => {
        setData(res?.data);
        Swal.fire({
          title: 'Note Deleted',
          text: 'Note Deleted Successfuly',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      });
    });
  };
  useEffect(() => {
    if (targetNoteId && cardRefs.current[targetNoteId]) {
      setTimeout(() => {
        cardRefs.current[targetNoteId].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 200); // slight delay to ensure DOM is painted
      setHighlightedNoteId(targetNoteId);
      const resetTimeout = setTimeout(() => {
        setHighlightedNoteId(null);
      }, 2000);
      return () => clearTimeout(resetTimeout);
    }
  }, [targetNoteId]);
  return (
    <Box sx={{ padding: '0 12px' }}>
      <Global styles={globalStyles} />
      {data?.map((item, index) => {
        return (
          <Card
            key={item?.noteId}
            ref={(el) => (cardRefs.current[item?.noteId] = el)}
            sx={{
              margin: '15px 5px',
              padding: '20px',
              boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
              borderRadius: '5px',
              ...(highlightedNoteId === item.noteId ? highlightStyle : {}),
            }}
          >
            <Grid container>
              <Grid xs={12}>
                <Grid
                  container
                  sx={{
                    display: 'flex',
                    flexDirection: matchessm ? 'column' : 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: matchessm ? '5px' : '0px',
                  }}
                >
                  <Grid xs={12} sm={6}>
                    <Typography sx={notesSubject}>
                      Subject : {item.subject}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      display: 'flex',
                      justifyContent: matchessm ? 'center' : 'flex-end',
                    }}
                    xs={12}
                    sm={6}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: ' center',
                        gap: matchessm ? '5px' : '20px',
                        marginRight: matchessm ? '10px' : '40px',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: matchessm ? '12px' : '16px',
                          fontWeight: 500,
                          padding: '3px 10px',
                          borderRadius: '10px',
                          background: '#345B83',
                          color: 'white',
                          fontFamily: 'poppins',
                        }}
                      >
                        {ownercardprop ? '#VendorReport' : '#BuyerReport'}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: matchessm ? '12px' : '16px',
                          fontWeight: 500,
                          padding: '3px 10px',
                          borderRadius: '10px',
                          background: '#F39800',
                          color: 'white',
                          fontFamily: 'poppins',
                        }}
                      >
                        #Private
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: matchessm ? '5px' : '10px',
                      }}
                    >
                      <Card sx={{ display: 'flex', flexDirection: 'column' }}>
                        <IconButton sx={{ padding: '0 !important' }}>
                          <KeyboardArrowUpIcon />
                        </IconButton>
                        <IconButton sx={{ padding: '0 !important' }}>
                          <KeyboardArrowDownIcon />
                        </IconButton>
                      </Card>
                      <IconButton disableRipple>
                        <ArrowDown />
                      </IconButton>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              xs={12}
              sx={{
                display: 'flex',
                alignItems: matchessm ? 'flex-start' : 'center',
                gap: matchessm ? '5px' : '10px',
                flexDirection: matchessm ? 'column' : 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography sx={notesMidLine}>
                Created : {item?.createdAt}
              </Typography>
              <Typography sx={notesMidLine}>
                Address : {item?.propertyAddress}
              </Typography>
            </Grid>
            <Grid xs={12}>
              <Typography
                sx={{
                  color: '#200E32',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                }}
              >
                {item.notesMessage}
              </Typography>
            </Grid>
            <Grid
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <IconButton
                onClick={() => {
                  setNoteToEdit(item);
                  setIsNoteEdit(true);
                  setTabValue((prev) => {
                    if (prev !== 0) {
                      setTimeout(() => {
                        updateNoteScrollRef.current?.scrollIntoView({
                          behavior: 'smooth',
                          block: 'end',
                        });
                      }, 0);
                    } else {
                      updateNoteScrollRef.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'end',
                      });
                    }
                    return 0;
                  });
                }}
              >
                <TaskEditIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleDeleteNote(item);
                }}
              >
                <TaskDeleteIcon />
              </IconButton>
            </Grid>
          </Card>
        );
      })}
      {data?.length == 0 && (
        <Typography
          sx={{
            fontWeight: 400,
            fontFamily: 'poppins',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '25px',
            color: '#666666',
          }}
        >
          No notes available
        </Typography>
      )}
    </Box>
  );
}

function AllActivities() {
  return (
    <Typography sx={{ textAlign: 'center', padding: '20px' }}>
      <Typography
        sx={{
          fontWeight: 400,
          fontFamily: 'poppins',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '15px',
          color: '#666666',
        }}
      >
        No activities found
      </Typography>
    </Typography>
  );
}

function CommunicationCard({
  buyerId,
  ownercardprop,
  marketShow,
  communicationData,
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { setIschatopen } = useContext(datacontext);

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };

  return (
    <>
      <Grid sx={{ paddingBottom: '15px' }}>
        {communicationData?.length > 0 ? (
          communicationData?.map((item, id) => (
            <Grid
              sx={{ padding: '0px 20px 10px 20px', cursor: 'pointer' }}
              onClick={() => {
                onShowChat(item?.binder?.id);
              }}
            >
              <Card
                key={item?.binder?.id} // Use a unique key for each rendered Card
                sx={messageCardCont}
                style={{
                  display: 'block',
                }}
              >
                <Typography
                  sx={displayFlexColumn}
                  style={{ justifyContent: 'space-between' }}
                >
                  <Typography
                    style={{
                      justifyContent: 'space-between',
                      display: 'flex',
                      marginBottom: '5px',
                    }}
                  >
                    <Typography sx={{ ...poppins500, ...fontsize14 }}>
                      {item?.binder?.name}
                    </Typography>
                    <Typography
                      style={{ textAlign: 'right' }}
                      sx={{
                        ...poppins400,
                        ...fontsize8,
                        ...lastseen6,
                        background:
                          item?.binder?.unread_feeds > 0
                            ? '#d32f2f'
                            : 'rgba(217, 217, 217, 0.28)',
                        color:
                          item?.binder?.unread_feeds > 0 ? 'white' : 'black',
                      }}
                    >
                      {/* {item?.binder?.unread_feeds} Display some value related to the binder */}
                      {item?.binder?.unread_feeds}
                    </Typography>
                  </Typography>
                  <Typography
                    sx={{ ...poppins400, ...fontsize10, ...lastseen }}
                  >
                    Last Activity:{' '}
                    {dayjs(item?.binder?.feeds_timestamp).format(
                      'On MMM D, YYYY h:mm A'
                    )}{' '}
                    {/* Display some date related to the binder */}
                  </Typography>
                  <Typography
                    style={{
                      justifyContent: 'space-between',
                      display: 'flex',
                    }}
                  >
                    <Typography
                      sx={displayFlex}
                      style={{
                        alignItems: 'center',
                        paddingTop: '10px',
                      }}
                    >
                      <Typography>
                        <CommunicationAvataGroup icon={item?.binder?.users} />
                      </Typography>
                      <Typography sx={{ ...poppins400, ...fontsize10 }}>
                        &nbsp;{item?.binder?.users?.length}
                      </Typography>
                    </Typography>
                    <Typography style={{ display: 'flex', alignItems: 'end' }}>
                      <ForwardArrow />
                    </Typography>
                  </Typography>
                </Typography>
              </Card>
            </Grid>
          ))
        ) : communicationData?.data?.binders?.length < 1 ? (
          <Typography sx={{ textAlign: 'center', padding: '20px' }}>
            <Typography
              sx={{
                fontWeight: 400,
                fontFamily: 'poppins',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '25px',
                color: '#666666',
              }}
            >
              No binders available currently
            </Typography>
          </Typography>
        ) : (
          <Typography
            sx={{
              fontWeight: 400,
              fontFamily: 'poppins',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '25px',
              color: '#666666',
            }}
          >
            No communication available
          </Typography>
        )}
      </Grid>

      {modalIsOpen && <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />}
    </>
  );
}

export const CommunicationAvataGroup = ({ icon = [] }) => {
  const [isShown, setIsShown] = useState(false);

  return (
    <AvatarGroup
      spacing={isShown ? 1 : 24}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      {icon?.length > 0 &&
        icon.map((item, index) => {
          const first = item?.user?.first_name || item?.first_name || '';
          const last = item?.user?.last_name || item?.last_name || '';
          const initials = `${first[0] || ''}${last[0] || ''}`.toUpperCase();

          return (
            <Avatar
              key={item?.user?.id || item?.id || index}
              src={item?.user?.picture_uri || item?.picture_uri || undefined}
              alt={`${first} ${last}`}
              sx={{
                height: 26,
                width: 26,
                fontSize: '12px',
                bgcolor:
                  item?.user?.picture_uri || item?.picture_uri
                    ? 'transparent'
                    : '#666',
                transition: '300ms',
              }}
            >
              {!item?.user?.picture_uri && !item?.picture_uri && initials}
            </Avatar>
          );
        })}
    </AvatarGroup>
  );
};

export const TaskListCard = ({
  todo,
  objectType,
  addedBy,
  description,
  createdTime,
  dueTime,
  completed,
  titleName,
  pending,
  taskToEdit,
  setTaskToEdit,
  selectedProperty,
  proid,
  transId,
  binderId,
  buyerId,
  setIsEdit,
  getTask,
  updateTaskScrollRef,
  updateNoteScrollRef,
  tabValue,
  setTabValue,
  isHighlighted,
}) => {
  const [isChecked, setChecked] = useState(completed);
  const handleCheckboxChange = (val) => {
    if (val == false) {
      setChecked(!isChecked);
      const params = {
        transId: transId,
        binderId: binderId,
        assigneeId: Number(buyerId),
        isDone: 1,
        isDelete: 0,
        propertyId: String(proid || 0),
      };
      postApiCall(USER_UPDATETASK, params).then((res) => {
        getTask();
      });
    }
  };

  const handleDeleteTask = () => {
    const inputData = {
      binderId: binderId,
      transId: transId,
      assigneeId: buyerId,
      isDelete: 1,
    };
    postApiCall(USER_UPDATETASK, inputData).then((res) => {
      if (res?.data?.status == 1) {
        setTaskToEdit(null);
        setIsEdit(false);
        getTask();
        Swal.fire({
          title: 'Delete Task',
          text: res?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  const theme = useTheme();
  const matches1800 = useMediaQuery(theme.breakpoints.down(1800));
  const matches1200 = useMediaQuery(theme.breakpoints.down(1200));

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: '5px',
        borderColor: 'transparent',
        boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
        padding: '15px',
        bgcolor: 'white',
        ...(isHighlighted && {
          animation: 'blinkEffect 2s ease-in-out 2',
          border: '2px solid rgb(25, 118, 210)',
          borderRadius: '6px',
          '@keyframes blinkEffect': {
            '0%': { backgroundColor: 'rgb(229, 239, 255)' },
            '50%': { backgroundColor: 'rgba(25, 118, 210, 0.15)' },
            '100%': { backgroundColor: 'rgb(229, 239, 255)' },
          },
        }),
      }}
    >
      <Stack
        direction={'row'}
        spacing={2}
        justifyContent={'space-between'}
        alignItems={'center'}
        mb={1}
      >
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
          style={{ width: '80%', marginLeft: '-40px' }}
        >
          <Checkbox
            checked={isChecked}
            icon={<CheckedRoundIconUnchecked />}
            checkedIcon={<CheckedRoundIcon />}
            onClick={() => {
              handleCheckboxChange(isChecked);
            }}
            inputProps={{ 'aria-label': 'Checkbox' }}
            disableRipple
          />
          <Typography
            // component={"del"}
            sx={{
              ...poppins500,
              fontSize: '16px',
              textDecoration: completed ? 'line-through' : 'none',
            }}
          >
            {/* Task : Call */}
            Task:{' '}
            {objectType === 'TODO'
              ? 'To Do'
              : objectType
              ? `${objectType.charAt(0).toUpperCase()}${objectType.slice(1)}`
              : ''}
          </Typography>
        </Stack>
        <IconButton disableRipple>
          <ArrowDown />
        </IconButton>
      </Stack>
      <Stack direction="row" alignItems="center" gap="50px">
        <Typography
          component={'div'}
          sx={{
            ...poppins500,
            fontSize: '14px',
            color: pending ? '#E45857' : '#4CAF50',
            // color:"rgba(228, 88, 87, 1)"
          }}
        >
          {/* today */}
          {dueTime}
        </Typography>
        {pending && (
          <Button
            sx={{
              borderRadius: '30px',
              background: '#F939391A',
              fontSize: '12px',
              textAlign: 'center',
              ...poppins600,
              height: '30px',
            }}
            style={{ color: '#E45857' }}
          >
            OVERDUE
          </Button>
        )}
      </Stack>
      <Stack
        direction={matches1800 ? 'column' : 'row'}
        spacing={2}
        alignItems={matches1800 ? 'left' : 'center'}
        mb={1}
      >
        <Typography sx={{ ...poppins400, fontSize: '10px', color: '#666666' }}>
          {/* Created: 15 May (9:01am){" "} */}
          Created: {createdTime}{' '}
        </Typography>
        {addedBy && (
          <Typography
            sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
          >
            {/* Added by Kiel Glass{" "} */}
            Added by {addedBy}{' '}
          </Typography>
        )}
        <Typography
          whiteSpace={!matches1200 && 'nowrap'}
          display={'flex'}
          alignItems={'center'}
          gap={1}
          justifyContent={matches1800 ? 'left' : 'center'}
          sx={{
            ...poppins300,
            fontSize: '12px',
            color: '#666666',
          }}
        >
          <LocationIcon />
          {selectedProperty}
        </Typography>
      </Stack>
      <Stack
        direction={'row'}
        spacing={2}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography
          sx={{
            ...poppins400,
            fontSize: '14px',
            color: '#200E32',
            width: '80%',
          }}
        >
          <span style={{ fontWeight: '600' }}>{titleName}</span> {description}{' '}
        </Typography>
        <Box>
          <IconButton
            onClick={() => {
              setTaskToEdit(todo);
              setIsEdit(true);
              setTabValue((prev) => {
                if (prev !== 1) {
                  setTimeout(() => {
                    updateTaskScrollRef.current?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'end',
                    });
                  }, 0);
                } else {
                  updateTaskScrollRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                  });
                }
                return 1;
              });
            }}
          >
            <TaskEditIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              handleDeleteTask();
            }}
          >
            <TaskDeleteIcon />
          </IconButton>
        </Box>
      </Stack>
    </Card>
  );
};
